/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import GridTable from "@nadavshaar/react-grid-table";

class AgentGifts extends Component {
  state = {
    data: {
      nameAr: "",
      nameKu: "",
      nameEn: "",
      descAr: "",
      descKu: "",
      descEn: "",
      categoryId: "",
      qunatity: "",
      requiredDiamonds: "",
      isActive: null,
      file: null,
    },

    contentHeader: "جوائز السباكين",
    addButtonLabel: "اضافة نوع",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetPipefitterGifts",
    singleItemUrl: "/api/data/GetPipefitterGift",
    addUrl: "/api/data/AddPipefitterGift",
    editUrl: "/api/data/EditPipefitterGift",
    deleteUrl: "/api/data/DeletePipefitterGift",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "اضافة جائزة",
    modalSubmitButtonLabelAdd: "اضافة",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "تعديل جائزة",
    modalSubmitButtonLabelEdit: "تعديل",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,
    allTrueFalse: [
      { label: "نعم", value: true },
      { label: "لا", value: false },
    ],
    allCategories: [],

    tableData: [],
    tableColumns: [
      {
        id: 1,
        label: "الاسم",
        field: "NAME_AR",
      },
      {
        id: 2,
        label: "النوع",
        field: "CATEGORY_NAME",
      },
      {
        id: 3,
        label: "العدد",
        field: "QUANTITY",
      },
      {
        id: 4,
        label: "الماسات المطلوبة",
        field: "REQUIRED_DIAMONDS",
      },
      {
        id: 5,
        label: "فعال",
        field: "IS_ACTIVE",
      },
      {
        id: 6,
        label: "تاريخ الادخال",
        field: "INSERT_DATE",
      },
      {
        id: 7,
        label: "تاريخ التعديل",
        field: "LAST_UPDATE",
      },
      {
        id: 8,
        field: "IMG_PATH",
        label: "الصورة",
        cellRenderer: ({ data }) => {
          return (
            <a href={data.IMG_PATH} target="blank" style={{ color: "black" }}>
              View File
            </a>
          );
        },
      },
      {
        id: 9,
        label: "الأوامر",
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB01"]) && (
                <div className="inner" title="تعديل">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB02"]) && (
                <div className="inner" title="حذف">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ],
  };

  componentDidMount() {
    this.getData();
    this.getAllCategories();
  }

  getAllCategories() {
    post(
      "/api/data/GetAllPipefitterGiftCategories",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        allCategories: apiResponse.data.respData.data,
      });
    });
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["nameAr"] = apiResponse.data.respData.data[0].NAME_AR;
      data["nameEn"] = apiResponse.data.respData.data[0].NAME_EN;
      data["nameKu"] = apiResponse.data.respData.data[0].NAME_KU;
      data["descAr"] = apiResponse.data.respData.data[0].DESC_AR;
      data["descKu"] = apiResponse.data.respData.data[0].DESC_KU;
      data["descEn"] = apiResponse.data.respData.data[0].DESC_EN;
      data["categoryId"] = apiResponse.data.respData.data[0].CATEGORY_ID;
      data["qunatity"] = apiResponse.data.respData.data[0].QUANTITY;
      data["requiredDiamonds"] =
        apiResponse.data.respData.data[0].REQUIRED_DIAMONDS;
      data["isActive"] = apiResponse.data.respData.data[0].IS_ACTIVE;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: "حذف الجائزة",
      message: "هل أنت متأكد من حذف هذه الجائزة",
      buttons: [
        {
          label: "نعم",
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        {
          label: "الغاء",
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    const data = new FormData();
    if (this.state.data.file && this.state.data.file !== null) {
      data.append("File", this.state.data.file, this.state.data.file.name);
    }

    data.append("requestData", JSON.stringify(submitData));

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      data,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    return (
      <div className="sys-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{this.state.contentHeader}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB00"]) && (
              <Button
                label={this.state.addButtonLabel}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode
                ? this.state.modalHeaderEdit
                : this.state.modalHeaderAdd}
            </h5>
          }
          footer={
            <div>
              <Button
                label={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonLabelEdit
                    : this.state.modalSubmitButtonLabelAdd
                }
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label="الغاء"
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "nameAr",
                label: "الاسم بالعربي",
                disabled: false,
              },
              {
                type: "text",
                id: "nameEn",
                label: "الاسم الانكليزي",
                disabled: false,
              },
              {
                type: "text",
                id: "nameKu",
                label: "الاسم بالكردي",
                disabled: false,
              },
              {
                type: "text",
                id: "descAr",
                label: "الوصف بالعربي",
                disabled: false,
              },
              {
                type: "text",
                id: "descEn",
                label: "الوصف الانكليزي",
                disabled: false,
              },
              {
                type: "text",
                id: "descKu",
                label: "الوصف بالكردي",
                disabled: false,
              },
              {
                type: "text",
                id: "qunatity",
                label: "الكمية",
                disabled: false,
              },
              {
                type: "text",
                id: "requiredDiamonds",
                label: "الماسات المطلوبة",
                disabled: false,
              },
              {
                type: "dropdown",
                id: "categoryId",
                label: "الصنف",
                options: this.state.allCategories,
                disabled: false,
              },
              {
                type: "dropdown",
                id: "isActive",
                label: "فعال",
                options: this.state.allTrueFalse,
                disabled: false,
              },
              {
                type: "fileupload",
                id: "file",
                label: "الملف التعريفي",
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <GridTable
          columns={this.state.tableColumns}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 30, 40]}
          showColumnVisibilityManager={false}
          texts={{
            search: "بحث:",
            totalRows: "إجمالي عدد البيانات:",
            rows: "الصف:",
            selected: "المحدد",
            rowsPerPage: "عدد الصفوف في الصفحة:",
            page: "الصفحة:",
            of: "من",
            prev: "السابق",
            next: "التالي",
            columnVisibility: "اظهار الاعمدة",
          }}
        />
      </div>
    );
  }
}

export default AgentGifts;
